import * as React from 'react';

var _circle, _path, _path2;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgXdc = function SvgXdc(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 48 48"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 24,
        cy: 24,
        r: 24,
        fill: "#131619"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#9FF3FF",
        d: "M27.792 23.61 38.475 10h-6.31q-1.955.02-3.386 1.855l-5.303 6.794-5.302-6.794Q16.722 10 14.787 10h-4.161q-1.065 0-1.065.898 0 .45.407.957L19.16 23.61l-5.762 7.416-3.991 5.139Q9 36.69 9 37.122q.117.879 1.084.878h4.123q1.935 0 3.367-1.835l5.903-7.595 5.903 7.595Q30.812 38 32.747 38h6.254L27.793 23.61z"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#9FF3FF",
        d: "m29.77 23.633 5.539 7.098V16.536z"
    })));
};

export { SvgXdc as ReactComponent };
//# sourceMappingURL=XDC.svg.es.js.map
